// export const CDNurl = 'https://storage-api.pixray.com/Download/Image/';
export const CDNurl = 'https://storage-api.pixray.com/v1/documents/';
export const LogsInterval = 60000;
